import React, { useEffect, useRef, useState } from "react";
import { Spin, Empty } from "antd";
import { SendOutlined } from "@ant-design/icons";
import moment from "moment";
import { ButtonItem, TextAreaItem } from "../../../../Components/Items";
import { nombreDeUsuario } from "./nombreUsuario";
import AvisoHorario from "./AvisoHorario";
import { SOPORTE_TEMA, HORARIO_ATENCION_CORTO } from "./fasesSoporte";

/**
 * Hilo de mensajes de un TicketSoporte + composer de texto. Reusado tanto en la
 * burbuja del cliente (perspectivaAgente=false) como en el modal de un agente
 * (perspectivaAgente=true) — solo cambia de qué lado se alinea cada burbuja.
 */
const HiloMensajesSoporte = ({
  mensajes,
  loading,
  enviando,
  onEnviar,
  perspectivaAgente,
  soloLectura,
  textoSoloLectura,
  usuarioId,
}) => {
  const [texto, setTexto] = useState("");
  const listaRef = useRef(null);

  useEffect(() => {
    if (listaRef.current) {
      listaRef.current.scrollTop = listaRef.current.scrollHeight;
    }
  }, [mensajes]);

  const enviar = () => {
    if (!texto.trim()) return;
    onEnviar(texto.trim());
    setTexto("");
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
      <div
        ref={listaRef}
        style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: 16,
          backgroundColor: SOPORTE_TEMA.bg,
        }}
      >
        {loading ? (
          <div style={{ textAlign: "center", paddingTop: 30 }}>
            <Spin />
          </div>
        ) : !mensajes.length ? (
          <Empty description="Sin mensajes todavía" />
        ) : (
          mensajes.map((m) => {
            if (m.esSistema) {
              return (
                <div key={m._id} style={{ textAlign: "center", margin: "10px 0" }}>
                  <span
                    style={{
                      fontSize: 11,
                      color: SOPORTE_TEMA.textSecondary,
                      backgroundColor: SOPORTE_TEMA.border,
                      borderRadius: 10,
                      padding: "3px 10px",
                    }}
                  >
                    {m.texto} · {moment(m.createdAt).format("DD/MM HH:mm")}
                  </span>
                </div>
              );
            }

            const autorId = m.usuarioId?._id || m.usuarioId;
            const propio = perspectivaAgente
              ? !!m.esAgente
              : usuarioId
                ? String(autorId) === String(usuarioId)
                : !m.esAgente;
            const etiqueta = m.esAgente
              ? perspectivaAgente
                ? nombreDeUsuario(m.usuarioId, "Soporte Biwo")
                : "Soporte Biwo"
              : m.esRevisor
                ? `${nombreDeUsuario(m.usuarioId, "Tu empresa")} · Revisión`
                : nombreDeUsuario(m.usuarioId, "Usuario");
            return (
              <div
                key={m._id}
                style={{
                  display: "flex",
                  justifyContent: propio ? "flex-end" : "flex-start",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    maxWidth: "75%",
                    padding: "8px 12px",
                    borderRadius: propio ? "12px 12px 2px 12px" : "12px 12px 12px 2px",
                    backgroundColor: propio ? SOPORTE_TEMA.bubbleOut : SOPORTE_TEMA.bubbleIn,
                    color: SOPORTE_TEMA.textPrimary,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  <div style={{ fontSize: 10, color: SOPORTE_TEMA.textSecondary, marginBottom: 2 }}>
                    {etiqueta}
                  </div>
                  {m.texto}
                  <div style={{ textAlign: "right", fontSize: 10, color: SOPORTE_TEMA.textSecondary, marginTop: 2 }}>
                    {moment(m.createdAt).format("HH:mm")}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {!perspectivaAgente && (
        <div
          style={{
            padding: "5px 12px",
            borderTop: `1px solid ${SOPORTE_TEMA.border}`,
            backgroundColor: SOPORTE_TEMA.bg,
            textAlign: "center",
          }}
        >
          <AvisoHorario compacto texto={`Atención: ${HORARIO_ATENCION_CORTO}`} />
        </div>
      )}

      {soloLectura ? (
        <div
          style={{
            padding: "10px 14px",
            borderTop: `1px solid ${SOPORTE_TEMA.border}`,
            backgroundColor: SOPORTE_TEMA.bg,
            fontSize: 12,
            color: SOPORTE_TEMA.textSecondary,
            textAlign: "center",
          }}
        >
          {textoSoloLectura || "Puedes consultar este chat; lo atiende quien levantó el reporte."}
        </div>
      ) : (
        <div
          style={{
            padding: 10,
            borderTop: `1px solid ${SOPORTE_TEMA.border}`,
            backgroundColor: SOPORTE_TEMA.surface,
            display: "flex",
            gap: 8,
            alignItems: "flex-end",
          }}
        >
          <TextAreaItem
            placeholder="Escribe un mensaje..."
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
                e.preventDefault();
                enviar();
              }
            }}
            autoSize={{ minRows: 1, maxRows: 5 }}
            disabled={enviando}
            style={{ borderRadius: 15, border: `1px solid ${SOPORTE_TEMA.border}`, padding: "6px 12px", boxShadow: "none", resize: "none" }}
          />
          <ButtonItem
            className="botonAgregar"
            naranja
            icon={<SendOutlined />}
            onClick={enviar}
            disabled={enviando || !texto.trim()}
          />
        </div>
      )}
    </div>
  );
};

export default HiloMensajesSoporte;
